export default __webpack_public_path__ + "static/media/playersite.1c87330a.png";